export const isLazyRouteMapExperimentEnabled = (): boolean =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	(typeof window !== 'undefined' && window.BUILD_EXPERIMENT_LAZY_ROUTE_MAP) ?? false;
